import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { AppNotification } from '@/lib/types';

/** Os avisos chegam por consulta a cada 30 s — o fim de uma operação sai do servidor sozinho. */
const POLL_MS = 30_000;

export const useNotifications = (options: { enabled?: boolean } = {}) =>
  useQuery({
    queryKey: ['notifications'],
    queryFn: () => api.get<{ items: AppNotification[]; unread: number }>('/api/notifications'),
    refetchInterval: POLL_MS,
    enabled: options.enabled ?? true,
  });

export function useMarkNotificationsRead() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => api.post<void>('/api/notifications/read-all'),
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['notifications'] }),
  });
}
